module.exports = __webpack_public_path__ + "static/main-22dcf0934311357beb726dc022378da1.jpg";